import CustomStore from 'devextreme/data/custom_store';
import { toast } from 'react-toastify';
import qs from 'qs';
import api from '~/services/api';
import { handleError, handleParams } from '~/services/helper';
import store from '~/store/Store';

export async function handleDeleteUser(setLoading) {
  setLoading(true);
  const id = store.getState().User.userID;
  toast.info('Excluido usuário', { autoClose: 1000 });
  await api
    .delete(`Usuario?pId=${id}`)
    .then(() => {
      toast.success('Usuário exluído');
      setLoading(false);
    })
    .catch(() => {
      toast.error('Usuário não foi excluido, tente novamente');
    });
}

export async function handleSubmit(event, usuario, setLoading) {
  event.preventDefault();
  setLoading(true);
  await api
    .post('/Usuario', usuario)
    .then(() => {
      toast.success('Cadastro realizado com sucesso');
      setLoading(false);
    })
    .catch(() => {
      toast.error('Algo deu errado durante o cadastro, tente novamente');
      setLoading(false);
    });
}

export async function handleUpdate(event, setLoading, userUpdate) {
  event.preventDefault();
  setLoading(true);
  await api
    .put('Usuario', userUpdate)
    .then(() => {
      toast.success('Atualização de dados feita com sucesso');
      setLoading(false);
    })
    .catch(() => {
      setLoading(false);
      toast.error('Erro na atualização de cadastro, tente novamente');
    });
}

function handleLoadUserData(loadOptions, idPessoaEmpresa) {
  const params = {
    idEmpresa: idPessoaEmpresa,
  };
  const newParams = handleParams(params, loadOptions);
  const url = `/Usuario/GetUsuarioByEmpresa?${qs.stringify(newParams)}`;
  return api
    .get(url)
    .then((res) => {
      const { data, totalCount } = res.data;
      return {
        data,
        totalCount,
      };
    })
    .catch((err) => {
      handleError('Erro ao carregar', err);
    });
}

async function handleDeleteUserGrid(key) {
  const url = `Usuario?pId=${key}`;
  return api
    .delete(url)
    .then(() => {
      toast.success('Usuario deletado com sucesso');
    })
    .catch((err) => handleError(err));
}

export const gridUserDataSource = (idPessoaEmpresa) => ({
  store: new CustomStore({
    key: 'id',
    load: (loadOptions) => handleLoadUserData(loadOptions, idPessoaEmpresa),
    remove: (key) => handleDeleteUserGrid(key),
  }),
});
